import { groupNameMap } from '../../vhc/model/constants';
import { ConditionStatus } from '../../vhc/model/types';
import { getRecordCheckItemType } from '../model/utils';
import styles from '../styles.module.scss';
import {
  VHCRecordCheckBrakeItemTypesVHCRecordLabourDto,
  VHCRecordCheckItemTypesVHCRecordLabourDto,
  VHCRecordCheckWheelTyreItemTypesVHCRecordLabourDto
} from 'api/generated';
import { useEffect, useMemo } from 'react';

interface LaboursProps {
  data?: {
    items:
      | (
          | VHCRecordCheckBrakeItemTypesVHCRecordLabourDto
          | VHCRecordCheckItemTypesVHCRecordLabourDto
          | VHCRecordCheckWheelTyreItemTypesVHCRecordLabourDto
        )[]
      | null
      | undefined;
  };
  handleViewOpen: (id: number) => void;
}

export const Labours = ({ data, handleViewOpen }: LaboursProps) => {
  const effectiveItems = useMemo(() => {
    const total = data && data.items && data.items?.length > 0 ? data.items : [];

    return total;
  }, [data]);

  return (
    <>
      <table className={`table  ${styles.responsiveTable}`}>
        <thead>
          <tr>
            <th className={styles.hideOnMobile} scope="col">
              Source
            </th>
            <th className={styles.hideOnMobile} scope="col">
              Labour Description
            </th>
            <th className={styles.hideOnMobile} scope="col">
              Labour Time
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {effectiveItems?.map((item, index) => {
            const nameOfItem = getRecordCheckItemType(item);
            const vHCRecordItemGroup = (item as any).vHCRecordItemGroup;
            return (
              <tr key={`${index}_labours`} className={`align-middle border-bottom ${styles.mobileRow}`}>
                <td className="text-info fw-bold">
                  {item.conditionId === ConditionStatus.WARNING && (
                    <span className={styles.dot} style={{ background: 'rgb(220, 191, 4)' }} />
                  )}
                  {item.conditionId === ConditionStatus.NOT_OK && (
                    <span className={styles.dot} style={{ background: 'rgb(255, 53, 8)' }} />
                  )}
                  {vHCRecordItemGroup !== undefined && groupNameMap[vHCRecordItemGroup]}-{nameOfItem}
                </td>
                <td className="fw-bold text-dark text-uppercase">{item.title}</td>
                <td className={styles.timeViewCell}>
                  <div className={styles.timeViewWrapper}>
                    <div>
                      <span className="fw-bold text-muted d-md-none">Labour Time </span>
                      <span className="fw-bold text-dark ">{(item.time / 60).toFixed(2)} h</span>
                    </div>
                    <button className={styles.viewBtn} onClick={() => handleViewOpen(item.checkItemId!)}>
                      View
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
